// @ts-nocheck
import { COLUMN, DELIMITER, KEY_VALUES, LAYOUT } from '../modules/constants'

// 'Targets Complied With' format eg '4 / 5'
const regexCompliedWith = new RegExp('^[0-5] \/ 5$');

export const exportToCsv = props => {
    // console.log('exportToCsv props:', props)

    const { filename, headers, rows, checkboxSettings } = props
    const csvRows = []

    // If 'checkboxSettings' is not undefined, append the checkbox checkboxSettings
    if (checkboxSettings)
        appendCheckboxSettings({ ...props, csvRows })
    else
        csvRows.push([])

    headers.forEach(element => {
        if (element.label && element.id !== COLUMN.SKIP_ME)
            csvRows.at(-1).push(element.label) // array.at(-1) is the last item in array
    })

    for (let index = 0; index < rows.length; index++) {
        let cellWithTooltips = rows[index].cellWithTooltips

        csvRows.push([])

        for (let j = 0; j < cellWithTooltips.length; j++) {

            var cell = cellWithTooltips[j]
            var value = cell.value

            // Replace 'Targets Complied With' value with sort value eg "3 / 5" > 3
            if (regexCompliedWith.test(value))
                value = cell.sortValue

            // Replace tick with "1"
            if (typeof value === "string")
                value = value.replace(LAYOUT.TICK, "1")

            switch (cell.type) {
                case "string":
                    csvRows.at(-1).push(`"${value}"`)
                    break
                case "date":
                    // tooltip is in format D MMM YYYY
                    csvRows.at(-1).push(cell.tooltip)
                    break
                default:
                    csvRows.at(-1).push(value)
            }
        }
    }

    exportCsv({ delimiterValue: DELIMITER.COMMA, filename: `Numerable - ${filename}.csv`, rows: csvRows })
}

// Append the checkbox checkboxSettings
// Egs "LSE group: All selected" or "Committee roles: Audit Chair, Audit Member"
const appendCheckboxSettings = ({ csvRows, filename, rawRowsLength, searchString, checkboxSettings }) => {

    // Add 'exceeded max rows' warning
    if (rawRowsLength > KEY_VALUES.MAX_CSV_ROWS)
        csvRows.push([`WARNING - INCOMPLETE EXPORT! - LIMITED TO ${KEY_VALUES.MAX_CSV_ROWS} ITEMS OUT ${rawRowsLength}`])

    // No 'title' for url so that it will be 'clickable'
    csvRows.push([`http://${location.host}${location.pathname}${location.search}`])
    csvRows.push([`Title: ${filename}`])
    csvRows.push([`Date: ${new Date()}`])

    // Add search-string if there is one
    if (!!searchString)
        csvRows.push([`Search: '${searchString}'`])

    checkboxSettings.forEach(checkbox => csvRows.push([`"${checkbox}"`]))
    csvRows.push([], [])
}

// (£) is changed to (Â£). So, remove %C2
const handleC2Bug = encodedUri => encodedUri.replaceAll("(%C2", "(")

const exportCsv = ({ delimiterValue, filename, rows }) => {
    var csvContent = "data:text/csv;charset=utf-8,"
    csvContent += delimiterValue === DELIMITER.TAB
        ? rows.map(e => e.join("\t")).join("\n") // tab separated
        : rows.map(e => e.join(",")).join("\n") // comma separated

    const encodedUri = handleC2Bug(encodeURI(csvContent))
    var link = document.createElement("a")
    link.setAttribute("href", encodedUri)
    link.setAttribute("download", filename)
    document.body.appendChild(link) // Required for FF

    link.click()
}
